import { TypedTable } from "@/components/ui/table/TypedTable";
import { createColumnHelper, tableFeatures, type RowSelectionState } from "@tanstack/react-table";
import { useMemo } from "react";
import { useOPEs, type LineaOPEPendiente } from "./ListadoOPE";
import { CommonFeatures } from "@/hooks/useTanstackTable";
import { getSelectionCell } from "@/components/ui/table/datatable";


interface TablaOPEsProps {
	readonly filtroProveedor: string;
	readonly selected: RowSelectionState;
	readonly setSelected: Setter<RowSelectionState>;
}
export function TablaOPEs(props: TablaOPEsProps) {
	const { data, error, isPending } = useOPEs();

	const { columns, features } = useMemo(() => Columns(), []);

	const filteredData = useMemo(() => {
		if (!data) return [];
		if (!props.filtroProveedor) return data;
		return data.filter(linea => linea.idProveedor == props.filtroProveedor);
	}, [data, props.filtroProveedor]);


	return (
		<TypedTable
			className="dataTable display"
			data={filteredData}
			columns={columns}
			features={features}

			getRowId={row => `${row.idOPE}_${row.idLineaOPE}`}
			selection={props.selected}
			setSelection={props.setSelected}

			noResultsMessage="No se encontraron pedidos"
			errorMessage="Error al cargar las líneas de OPE"
			isLoading={isPending}
			isError={error != null}
		/>
	);
}



function Columns() {
	const columnHelper = createColumnHelper<typeof features, LineaOPEPendiente>();
	const features = tableFeatures(CommonFeatures);

	const idAccesor = (linea: LineaOPEPendiente) => `#${String(linea.idOPE).padStart(3, "0")} - ${linea.idLineaOPE}`;
	const conjuntoAccesor = (linea: LineaOPEPendiente) => {
		return linea.loteConjunto == "0" ?
			`${linea.idConjunto} - ${linea.descConjunto}` :
			`${linea.idConjunto} - ${linea.descConjunto} - ${linea.loteConjunto}`;
	};
	const percentFormatter = new Intl.NumberFormat("es-ES", {
		style: "percent",
		minimumFractionDigits: 0,
		maximumFractionDigits: 2
	});

	const columns = columnHelper.columns([
		columnHelper.display({
			id: "checkbox",
			// header: () => <input type="checkbox" className="checkboxRow" style={{ height: 20 }} />,
			cell: (info) => getSelectionCell(info.row),
		}),
		columnHelper.accessor(idAccesor, { header: "ID" }),
		columnHelper.accessor("nombreProveedor", { header: "Proveedor" }),
		columnHelper.accessor(conjuntoAccesor, { id: "conjunto", header: "Conjunto" }),
		columnHelper.accessor("cantidadFabricar", { header: "Fabricar" }),
		columnHelper.accessor("cantidadRecibida", { header: "Recibida" }),
		columnHelper.accessor("percentEnviada", { header: "Enviada", cell: info => percentFormatter.format(info.getValue()) }),
	]);
	return { columns, features };
}